// hooks/api/useChatDetail.js
import { useQuery } from "@tanstack/react-query";
import { getChatDetail } from "api/chat";

export const useChatDetail = ({ id, timezone, onError }, options = {}) => {
  return useQuery({
    queryKey: ["chat-detail", id],
    queryFn: () => getChatDetail({ id, timezone }),
    enabled: !!id,
    onError,
    onSuccess: () => {},
    ...options,
  });
};
